import {isNullOrUndefined} from "../../../services/Validator";

export default function PreviewContentLayout({children}) {
    // Used in both PreviewFlashQuestionContent and PreviewExerciserContent
    // to frame

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={`overflow-auto bg-backgroundLight3 px-[16px] pb-[16px] w-full min-h-[640px] h-[640px] border-greyLight3 border-[1px] rounded-[16px] flex flex-col justify-start items-center`}>
            {/** Double div for handling scrolling bar only */}
            <div className={"bg-backgroundLight3 w-full flex flex-col justify-start items-center"}>
                {children}
            </div>
        </div>
    )
}